import React, { useContext } from "react";

import { FileRecordStatus } from "../../../../common/types/FileRecordStatus";
import { FileRecordStatusDetails } from "../../common/types/FileRecordStatusDetails";
import { RejectStatusDialog } from "../../details/sections/info/library/status/RejectStatusDialog";
import { FileRecordListingContext } from "../context/FileRecordListingContext";

type RejectSingleFileRecordsDialogProps = {
    itemId: string;
    onClose(): void;
    isOpen: boolean;
};

export const RejectSingleFileRecordDialog: React.VFC<RejectSingleFileRecordsDialogProps> = ({
    itemId,
    isOpen,
    onClose
}: RejectSingleFileRecordsDialogProps) => {
    const { updateFileRecordStatus } = useContext(FileRecordListingContext);

    const handleConfirm = (statusDetails?: FileRecordStatusDetails) => {
        updateFileRecordStatus(itemId, FileRecordStatus.Rejected, statusDetails);
        onClose();
    };

    return <RejectStatusDialog fileRecordId={itemId} isOpen={isOpen} onClose={onClose} onConfirm={handleConfirm} />;
};
